import { ActionType, getType } from 'typesafe-actions';

import {
  AccountingDate,
  AddNewDebtJournalEntriesResponseData,
  DebtJournalEntryResponseRow,
  SaveAccountingDatesResponseData,
  SaveDebtJournalEntriesResponseData,
} from '../types';

import * as debtJournalEntriesActions from './actions';

export type DebtJournalEntriesActionType = ActionType<
  typeof debtJournalEntriesActions
>;

export interface DebtJournalEntriesState {
  journalEntries: {
    data: DebtJournalEntryResponseRow[] | null;
    loading: boolean;
  };
  saveJournalEntries: {
    data: SaveDebtJournalEntriesResponseData | null;
    loading: boolean;
  };
  accountingDates: {
    data: AccountingDate[] | null;
    loading: boolean;
  };
  saveAccountingDates: {
    data: SaveAccountingDatesResponseData | null;
    loading: boolean;
  };
  addNewJournalEntries: {
    data: AddNewDebtJournalEntriesResponseData | null;
    loading: boolean;
  };
}

const initialState: DebtJournalEntriesState = {
  journalEntries: {
    data: null,
    loading: false,
  },
  saveJournalEntries: {
    data: null,
    loading: false,
  },
  accountingDates: {
    data: null,
    loading: false,
  },
  saveAccountingDates: {
    data: null,
    loading: false,
  },
  addNewJournalEntries: {
    data: null,
    loading: false,
  },
};

const debtJournalEntriesReducer = (
  state: DebtJournalEntriesState = initialState,
  action: DebtJournalEntriesActionType,
): DebtJournalEntriesState => {
  switch (action.type) {
    case getType(debtJournalEntriesActions.getDebtJournalEntries.request):
      return {
        ...state,
        journalEntries: {
          ...state.journalEntries,
          loading: true,
        },
      };

    case getType(debtJournalEntriesActions.getDebtJournalEntries.success):
      return {
        ...state,
        journalEntries: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.getDebtJournalEntries.failure):
      return {
        ...state,
        journalEntries: {
          ...state.journalEntries,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.saveDebtJournalEntries.request):
      return {
        ...state,
        saveJournalEntries: {
          ...state.saveJournalEntries,
          loading: true,
        },
      };

    case getType(debtJournalEntriesActions.saveDebtJournalEntries.success):
      return {
        ...state,
        saveJournalEntries: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.saveDebtJournalEntries.failure):
      return {
        ...state,
        saveJournalEntries: {
          ...state.saveJournalEntries,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.getAccountingDates.request):
      return {
        ...state,
        accountingDates: {
          ...state.accountingDates,
          loading: true,
        },
      };

    case getType(debtJournalEntriesActions.getAccountingDates.success):
      return {
        ...state,
        accountingDates: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.getAccountingDates.failure):
      return {
        ...state,
        accountingDates: {
          ...state.accountingDates,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.saveAccountingDates.request):
      return {
        ...state,
        saveAccountingDates: {
          ...state.saveAccountingDates,
          loading: true,
        },
      };

    case getType(debtJournalEntriesActions.saveAccountingDates.success):
      return {
        ...state,
        saveAccountingDates: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.saveAccountingDates.failure):
      return {
        ...state,
        saveAccountingDates: {
          ...state.saveAccountingDates,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.addNewDebtJournalEntries.request):
      return {
        ...state,
        addNewJournalEntries: {
          ...state.addNewJournalEntries,
          loading: true,
        },
      };

    case getType(debtJournalEntriesActions.addNewDebtJournalEntries.success):
      return {
        ...state,
        addNewJournalEntries: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(debtJournalEntriesActions.addNewDebtJournalEntries.failure):
      return {
        ...state,
        addNewJournalEntries: {
          ...state.addNewJournalEntries,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default debtJournalEntriesReducer;
